<template>
    <div class="empty component">
      <img :src="imageSrc" alt="empty"/>
      <p class="message text-sub-color">{{ displayText }}</p>
    </div>
  </template>
  
<script>
export default {
  name: 'Empty',
  props: {
    type: { type: String, default: 'note' }, // film, bulb, note
    text: { type: String, default: 'schedule' }
    // text: { type: String, default: 'Sorry, no information was found ！' }
  },
  computed: {
    imageSrc () {
      return require(`../../assets/images/${this.type}.svg`)
    },
    displayText () {
      switch (this.text) {
        case 'film':
          return this.$i18n.messages[this.$i18n.fallbackLocale].null.film
        default:
          return this.$i18n.messages[this.$i18n.fallbackLocale].null.schedule
      }
    }
  }
}
</script>
  
  <style lang="scss" scoped>
    .empty {
      text-align: center;
  
      img {
        margin-top: 40px;
      }
  
      .message {
        margin: 40px 0;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0.9px;
        opacity: .5;
      }
    }
  </style>
